import { useDispatch, useSelector } from "react-redux";
import {
  GetMealBreakUserList,
  mealBreakReportInfo,
  IsLoading,
  setLoading,
  GetWeekHeaders,
  selectPayPeriods,
} from "../redux/reducers/mealBreakReport.reducer";
import { useCallback, useEffect } from "react";
import { TimesheetsService } from "../services/timesheets";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";

export const useMealBreakReport = (
  currentPayPeriod: any,
  isInfoPayPeriodsLoaded: boolean
) => {
  const dispatch = useDispatch();

  const { userRolesList } = useSelector(selectUserRoles);

  const mealBreakUserList = useSelector(GetMealBreakUserList);
  const weekHeaders = useSelector(GetWeekHeaders);
  const isLoading = useSelector(IsLoading);

  const payPeriods = useSelector(selectPayPeriods);

  let currentPayPeriodForRequest;
  if (isInfoPayPeriodsLoaded) {
    if (currentPayPeriod) {
      currentPayPeriodForRequest = currentPayPeriod;
    } else {
      currentPayPeriodForRequest = {
        value:
          payPeriods.current.startDate.split("T")[0].replaceAll("-", "/") +
          " - " +
          payPeriods.current.endDate.split("T")[0].replaceAll("-", "/"),
        label:
          payPeriods.current.startDate.split("T")[0].replaceAll("-", "/") +
          " - " +
          payPeriods.current.endDate.split("T")[0].replaceAll("-", "/"),
        startDate: payPeriods.current.startDate,
        endDate: payPeriods.current.endDate,
      };
    }
  }

  const mealBreakReportResults = useCallback(async () => {
    dispatch(setLoading(true));
    if (isInfoPayPeriodsLoaded) {
      const results = await TimesheetsService.getMealBreakReportInfo(
        currentPayPeriodForRequest.startDate,
        currentPayPeriodForRequest.endDate
      );
      dispatch(mealBreakReportInfo(results));
    }
  }, [dispatch, currentPayPeriod, isInfoPayPeriodsLoaded]);

  useEffect(() => {
    mealBreakReportResults();
  }, [mealBreakReportResults]);

  return {
    isLoading,
    mealBreakUserList,
    userRolesList,
    weekHeaders,
  };
};
